import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ProductInventoryLevelQuery, ProductInventoryLevelQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductInventoryLevelQuery)
@Wrapper(ProductInventoryLevelQueryHandlerBase)
export class ProductInventoryLevelQueryHandler {
    public constructor(
        http: Http
    ) { }
}
